<template>
  <router-view :key="$i18n.locale" />
</template>

<script>
export default {
  name: "Localized"
};
</script>

<style scoped></style>
